module.exports = __webpack_public_path__ + "img/afkwirtualnebiuro.f217ee16.webp";